import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { toast } from "react-toastify";
import { FaCheck, FaCheckCircle, FaExclamationTriangle, FaFileContract, FaMicrophone, FaPlusCircle, FaQuestion, FaRegFilePdf, FaSave, FaSearch, FaTeamspeak, FaUsers, FaWhatsapp, FaWrench } from "react-icons/fa";
import { RiFolderTransferLine } from "react-icons/ri";
import { BACKEND } from "../../config/configEnvs";
import { BsClipboard2Check } from "react-icons/bs";
import { MdAutorenew, MdClose, MdCompareArrows, MdDocumentScanner } from "react-icons/md";
import { getFinalPriceCotDrawer, getPuntosFromSelectedServicesandAllServices } from "../../helpers/pricesCotizacion";
import AgregarServicio from "../cotizaciones/AgregarServicio";
import ItemRowServicioCotizacion from "../cotizaciones/ItemRowServicioCotizacion";
import ItemRowPagoCotizacion from "../cotizaciones/ItemRowPagoCotizacion";
import AgregarPago from "../cotizaciones/AgregarPago";
import Tooltip from "../ui/ToolTip";
import RenovarCotiDialog from "../dialogs/RenovarCotiDialog";
import NuevoClienteDialog from "../dialogs/NuevoClienteDialog";
import TransferirCotizacionDialog from "../dialogs/TransferirCotizacionDialog";
import DrawerRight from "../ui/DrawerRight";
import { FormatDateToDDMMYY } from "../../utils/FormatDate";
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';
import { CircularProgress } from "@mui/material";
import PDFMonstruoCreativo from "../dialogs/pdfCotizaciones/PDFMonstruoCreativo";
import PDFAllSavfe from "../dialogs/pdfCotizaciones/PDFAllSavfe";
import AddIcon from '@mui/icons-material/Add';
import PaymentsIcon from '@mui/icons-material/Payments';
import AgregarMultiplesPagos from "../cotizaciones/AgregarMultiplesPagos";
import DocumentosCotizacion from "../cotizaciones/DocumentosCotizacion";
import { AsignarCursos } from "../../utils/automateFuncions/AsignarCursos";
import { useSelector } from "react-redux";
import HandleUpdateSelectSelf from "../../utils/HandleUpdateSelectSelf";
import { CrearIncidencia } from "../../utils/automateFuncions/CrearIncidencia";
import ActualizarEstadoUsuario from "../../utils/automateFuncions/ActualizarEstadoUsuario";
import CloudIcon from '@mui/icons-material/Cloud';
import AutogenerarCotizacionHyD from "../cotizaciones/AutogenerarCotizacionHyD";
import HistorialCambiosPagos from "../cotizaciones/HistorialCambiosPagos";
import HistoryIcon from '@mui/icons-material/History';
import ObtenerMultiplicador from "../../utils/preciosPaises/obtenerMultiplicador";
import NormalizeText from "../../utils/normalizeValues/NormalizeText";
import ObtenerMoneda from "../../utils/preciosPaises/ObtenerMoneda";
import CallSection from "../seguimiento/CallSection";
import DinamicButton from "../ui/components/DinamicButton";
import GenerateContract from "../../utils/automateFuncions/GenerateContract";
import SpeechModal from "../cotizaciones/SpeechModal";
import ModalInDrawer from "../ui/ModalInDrawer";

const DrawerCotizacionDetails = ({ onClose, brands, open, dataDrawer, setCotizacionesList, cotizacionesList, paises, currencyExchanges }) => {

  const user = useSelector((state) => state.auth.user)
  const isAdmin = user?.area?.toUpperCase() === "ADMINISTRACION" && user?.puesto?.toUpperCase() !== "ASISTENTE"
  const { open: phoneDrawerOpen } = useSelector((state) => state.twilioPhone)
  const [openAddPago, setOpenAddPago] = useState(false);
  const [openAddMultiplesPagos, setOpenAddMultiplesPagos] = useState(false);
  const debounceIncidencia = useRef(null);

  const [allPlanesList, setAllPlanesList] = useState([]);
  const [comentario, setComentario] = useState("")
  const [openAddServicio, setOpenAddServicio] = useState(false);
  const [openGenerarCotizacionHyD, setOpenGenerarCotizacionHyD] = useState(false);
  const [openTransferirCoti, setOPenTransferirCoti] = useState(false);
  const [allServiciosList, setAllServiciosList] = useState([]);
  const [allClientesUserList, setAllClientesUserList] = useState([]);
  const [allServiciosCotizacionesList, setAllServiciosCotizacionesList] = useState([]);
  const [convertToFacturaActive, setConvertToFacturaActive] = useState(false);
  const [searchInputClientes, setSearchInputClientes] = useState("");
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [createNewClientActive, setCreateNewClientActive] = useState(false);
  const [isCopiedId, setIsCopiedId] = useState(false);
  const [empresas, setEmpresas] = useState([])
  const [selectedEmpresa, setSelectedEmpresa] = useState({})
  const [data, setData] = useState(null);
  const [estadoCotizacion, setEstadoCotizacion] = useState("");
  const [subEstadoCotizacion, setSubEstadoCotizacion] = useState("")
  const [tipoCotizacion, setTipoCotizacion] = useState("");
  const [serviciosList, setServiciosList] = useState([]);
  const [pagosList, setPagosList] = useState([]);
  const [openRenewCot, setOpenRenewCot] = useState(false);
  const [isDescuento, setIsDescuento] = useState(false);
  const [precioDescuento, setPrecioDescuento] = useState(0);
  const [tipoDescuento, setTipoDescuento] = useState("fijo"); //fijo - porcentaje
  const [isDescuentoOpen, setIsDescuentoOpen] = useState(false);
  const [igv, setIgv] = useState(false);
  const [pdfOpen, setPdfOpen] = useState(false);
  const [primeraCotizacion, setPrimeraCotizacion] = useState(false)
  const [brand, setBrand] = useState(null)
  const [ultimaActualizacionSubestado, setUltimaActualizacionSubestado] = useState(null)
  const [responsableVenta, setResponsableVenta] = useState("No definido")
  const [openSpeechModal, setOpenSpeechModal] = useState(false)
  const [openWhatsappModal, setOpenWhatsappModal] = useState(false)
  const [messageNote, setMessageNote] = useState("")
  const [fechaTentativaInicio, setFechaTentativaInicio] = useState("")
  
  const hostingDomainCot = allServiciosCotizacionesList.some(servicio => 
    servicio.servicio.id === "66c465aa5d02f2a631e4708c" ||
    servicio.servicio.id === "66c474b95d02f2a631e470a2" || 
    servicio.servicio.id === "66c475035d02f2a631e470ad" ||
    servicio.servicio.id === "66c474755d02f2a631e47097"
  )

  const [registrosLlamadas, setRegistrosLlamadas] = useState([])

  const getRegistrosLlamadas = async () => {
    try {
      
      let url = ""
      if (isAdmin) {
        url = `${BACKEND}/api/registroLlamadas?where[quotes][contains]=${dataDrawer.id}&limit=0`
      } else {
        url = `${BACKEND}/api/registroLlamadas?where[quotes][contains]=${dataDrawer.id}&limit=0&where[worker][equals]=${user.id}&where[category][equals]=Comercial`
      }

      const response = await axios.get(url)
      setRegistrosLlamadas(response.data.docs)
    } catch (error) {
      toast.error("No se pudieron obtener las llamadas relacionadas")
    }
  }

  useEffect(() => {
    if (dataDrawer) {
      getRegistrosLlamadas()
    }
  }, [dataDrawer])

  useEffect(() => {
    const updateServicesFacturacion = async () => {
      try {
        // Solo ejecutar si hay datos válidos
        if (!pagosList || pagosList.length === 0 || !allServiciosCotizacionesList || allServiciosCotizacionesList.length === 0) {
          return;
        }

        // Obtener servicios con deuda
        const unpayedServices = allServiciosCotizacionesList.filter(servicio => servicio.facturacion === "Deuda");
        
        if (unpayedServices.length === 0) {
          return; // No hay servicios con deuda
        }

        // Verificar si TODOS los pagos están pagados
        const todosLosPagosPagados = pagosList.every(pago => pago.pagado === true);
        
        // console.log("=== DEBUG FACTURACIÓN ===");
        // console.log("Total pagos:", pagosList.length);
        // console.log("Pagos pagados:", pagosList.filter(pago => pago.pagado === true).length);
        // console.log("Todos los pagos pagados:", todosLosPagosPagados);
        // console.log("Servicios con deuda:", unpayedServices.length);

        // Solo actualizar si TODOS los pagos están pagados
        if (todosLosPagosPagados) {
          console.log("✅ Actualizando servicios a PAGADO - Todos los pagos están pagados");
          
          const updatePromises = unpayedServices.map(servicio => 
            axios.put(`${BACKEND}/api/serviciosCotizaciones/${servicio.id}`, {
              facturacion: "Pagado",
            })
          );
          
          await Promise.all(updatePromises);
          
          // Actualizar el estado local para evitar re-renders innecesarios
          setAllServiciosCotizacionesList(prev => 
            prev.map(servicio => 
              servicio.facturacion === "Deuda" 
                ? { ...servicio, facturacion: "Pagado" }
                : servicio
            )
          );
          
          toast.success("Estado de facturación de servicios actualizado");
        } else {
          console.log("❌ No se actualiza - No todos los pagos están pagados");
        }

      } catch (error) {
        console.error("Error al actualizar facturación:", error);
        toast.error("Error al actualizar el estado de los servicios: " + error.message);
      }
    };

    // Agregar un pequeño delay para evitar race conditions
    const timeoutId = setTimeout(updateServicesFacturacion, 100);
    return () => clearTimeout(timeoutId);
  }, [pagosList, allServiciosCotizacionesList]);

  // useEffect(() => {
  //   const updateServicesFacturacion = async () => {
  //     try {
  //       const unpayedServices = allServiciosCotizacionesList.filter(servicio => servicio.facturacion === "Deuda")
  //       if (unpayedServices.length > 0) {
  //         const filterUnpayedPayments = pagosList.filter(pago => pago.pagado !== true)
  //         console.log("Pagos no pagado: " + filterUnpayedPayments.length)
  //         // const isAllPayed = pagosList.every(pago => pago.pagado === true)
  //         // if (isAllPayed)
  //         if (pagosList.length > 0 && filterUnpayedPayments.length === 0) {
  //           const updatePromises = unpayedServices.map(servicio => 
  //             axios.put(`${BACKEND}/api/serviciosCotizaciones/${servicio.id}`, {
  //               facturacion: "Pagado",
  //             })
  //           )
  //           await Promise.all(updatePromises)
  //           toast.success("Estado de facturación de servicios actualizado")
  //         }
  //       }
  //     } catch (error) {
  //       toast.error("Error al actualizar el estado de los servicios: " + error)
  //     }
  //   }

  //   updateServicesFacturacion()
  // }, [pagosList])
  
  // Modo incognito
  const [incognitMode, setIncognitMode] = useState(false)
  const [clientEmail, setClientEmail] = useState("")
  const [clientPassword, setClientPassword] = useState("")

  const [comparativo, setComparativo] = useState(false)
  
  const documentosRef = useRef();
  const [openHistorialCambiosPagos, setOpenHistorialCambiosPagos] = useState(false)
  const pdfMap = {
    "67ea9c110e2642a4b0b902e1": "PDFMonstruoCreativo",
    "67ea9c250e2642a4b0b902fa": "PDFW3b",
    "67ea9c2c0e2642a4b0b90313": "PDFMundoDigital",
    "67ea9c320e2642a4b0b9032c": "PDFAllSavfe",
    "67ea9c3e0e2642a4b0b90345": "PDFConviertelo",
    "67ea9c440e2642a4b0b9035e": "PDFLucuma",
  }

  const PDFComponents = {
    PDFMonstruoCreativo,
    PDFAllSavfe,
    // PDFW3b,
    // PDFMundoDigital,
    // PDFConviertelo,
    // PDFLucuma,
  }

  const allowUniquePayment = allServiciosCotizacionesList.some(s => s.servicio.tipoPago === "Mensual")
    
  const defaultPDF = "PDFMonstruoCreativo"
  const selectedPDFKey = pdfMap[brand]
  const SelectedPDFComponent = PDFComponents[selectedPDFKey] || PDFComponents[defaultPDF]

  const [loading, setLoading] = useState(false)

  // console.log("Pais: " + data?.cliente?.pais || data?.lead?.country)
  // console.log("Paises: " + paises?.length)

  const multiplicador = ObtenerMultiplicador({pais: data?.cliente?.pais || data?.lead?.country, paises: paises})
  const flagUrl = paises.find(p => NormalizeText(p.name) === NormalizeText(data?.cliente?.pais || data?.lead?.country))?.bandera?.url
  const currency = ObtenerMoneda({pais: data?.cliente?.pais || data?.lead?.country, paises: paises})
  const currencyExchange = currencyExchanges[currency]

  // console.log(currency)
  // console.log(currencyExchange)

  // console.log(data)

  // console.log("Flag URL: " + flagUrl)

  //console.log("Multiplicador: " + multiplicador)

  const { subtotalSinIGV, igvTotal, totalConIGV } = getFinalPriceCotDrawer({
    serviciosCotizaciones: allServiciosCotizacionesList,
    allServiciosList: allServiciosList,
    porcentajeIGV: 18,
    multiplicador: multiplicador
  })

  // Verificar si hay pagos sin fecha límite
  const hasPaymentsWithoutDueDate = pagosList.some(pago => !pago.fechaLimite)

  // URL del contrato firmado si existe (acepta objeto con url o string directa; soporta 'documentoFirmado' y 'documentofirmado')
  const signedContractUrl = data?.documentoFirmado
    ? (typeof data.documentoFirmado === 'string' ? data.documentoFirmado : data.documentoFirmado.url)
    : (data?.documentofirmado
      ? (typeof data.documentofirmado === 'string' ? data.documentofirmado : data.documentofirmado.url)
      : null)

  const getServicios = async () => {
    await axios
      .get(`${BACKEND}/api/servicios?limit=1000`)
      .then(({ data }) => setAllServiciosList(data.docs))
      .catch((e) => console.log(e));
  };

  const getEmpresas = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/empresas?limit=0`)
      setEmpresas(response.data.docs)
    } catch (error) {
      console.log(error)
    }
  }

  const getInitialClientesWithQuery = async () => {
    await axios
      .get(
        `${BACKEND}/api/clientesUser?where[nombreComercial][like]=${searchInputClientes}`
      )
      .then(({ data }) => setAllClientesUserList(data.docs))
      .catch((e) => console.log(e));
  };

  const getInitialClientesWithQueryOnRefresh = async () => {
    await axios
      .get(`${BACKEND}/api/clientesUser`)
      .then(({ data }) => setAllClientesUserList(data.docs))
      .catch((e) => console.log(e));
  };

  const getSubmitClientes = async (event) => {
    event.preventDefault();
    await getInitialClientesWithQuery();
  };

  const toastId = useRef(null)

  const createProcessAsync = async () => { // Crear proceso para los proyectos en caso el servicio tenga una plantilla asignada
    const servicesWithTemplate = allServiciosCotizacionesList.filter((item) => item?.servicio?.template)
    if (servicesWithTemplate.length === 0) {
      toast.info("No hay servicios con plantilla para generar procesos")
      return
    }

    let generatedCount = 0
    let skippedCount = 0
    let failedCount = 0

    toastId.current = toast.loading(`Generando procesos (0/${servicesWithTemplate.length})...`)

    for (const item of servicesWithTemplate) {
      // console.log("Generacion de procesos para: " + servicesWithTemplate.length + " servicios")
      // console.log("Servicio: " + item.servicio.name + " tiene una plantilla asignada")
      try {
        const response = await axios.get(`${BACKEND}/api/fasesProyectos?where[service][equals]=${item.id}`)
        if (response.data.docs.length > 0) {
          // console.log("Proceso ya existe para el servicio: " + item.servicio.name)
          skippedCount++
          toast.update(toastId.current, {
            render: `Generando procesos (${generatedCount}/${servicesWithTemplate.length})...`,
            isLoading: true,
          })
          continue
        }

        // console.log("Generando proceso para el servicio: " + item.servicio.name)
        await axios.post(`${BACKEND}/api/processMiddleware/generateProcess`, {
          serviceName: item.servicio.template,
          serviceId: item.id,
        })
        generatedCount++
        toast.update(toastId.current, {
          render: `Generando procesos (${generatedCount}/${servicesWithTemplate.length})...`,
          isLoading: true,
        })
      } catch (error) {
        console.log(error)
        failedCount++
        toast.update(toastId.current, {
          render: `Generando procesos (${generatedCount}/${servicesWithTemplate.length})... (errores: ${failedCount})`,
          isLoading: true,
        })
      }
    }

    const finalMessage = `Procesos generados: ${generatedCount}/${servicesWithTemplate.length}. Omitidos: ${skippedCount}${failedCount > 0 ? `. Errores: ${failedCount}` : ""}.`

    toast.update(toastId.current, {
      render: finalMessage,
      type: failedCount > 0 ? "warning" : "success",
      isLoading: false,
      autoClose: 4000,
      closeOnClick: true,
    })
  }

  const asignarFormulario = async (tipo, item) => {   /// Asignar formulario de entrada
    try {
      const respuestasFormulariosServicio = await axios.get(
        `${BACKEND}/api/formularioServicio?where[servicio][equals]=${item?.servicio?.id}&where[tipo][equals]=${tipo}`
      );
      if (respuestasFormulariosServicio.data?.docs.length === 0) {
        return;
      } else {
        await axios.post(`${BACKEND}/api/formularioServicioRespuestas`, {
          formulario: respuestasFormulariosServicio.data.docs[0].id,
          servicioCotizacion: item.id,
        });
      }
    } catch (error) {
      console.log(error)
    }
  };

  const convertToFactura = async () => { // Convertir a factura

    if (puntosList.length === 0) {
      await axios
        .post(`${BACKEND}/api/puntosServicioCliente`, {
          cotizacion: data?.id,
          cliente: selectedCliente?.id,
          puntos: 0,
        })
        .then(({ data }) => setPuntosList([data.doc]))
        .catch((e) => console.log(e));
    }

    try {
      const responseCotizacion = await axios.put(
        `${BACKEND}/api/cotizaciones/${data?.id}`,
        {
          cliente: selectedCliente?.id,
          tipo: "Factura",
          estado: "Exito",
          subEstado: "Exito",
        }
      );

      AsignarCursos(allServiciosCotizacionesList, clientEmail, clientPassword)
      createEventUpdateStatus(data.lead.id, data.cotizador.id, "Exito")
      createProcessAsync()

      for (const item of allServiciosCotizacionesList) {
        asignarFormulario("entrada", item)
      }

      setTipoCotizacion(responseCotizacion.data.doc.tipo);
      setData((prev) => ({
        ...prev,
        cliente: responseCotizacion.data.doc.cliente,
      }));
      setEstadoCotizacion("Exito");
      setTipoCotizacion("Factura");
      setConvertToFacturaActive(false);
      getServiciosCotizaciones()
      toast.success("Convertido a factura exitosamente");
    } catch (error) {
      toast.success("Error al convertir a factura, intente nuevamente");
    }
  };

  const getServiciosCotizaciones = async () => {
    await axios
      .get(
        `${BACKEND}/api/serviciosCotizaciones?where[cotizacion][equals]=${dataDrawer?.id}&limit=0&depth=4`
      )
      .then(({ data }) => setAllServiciosCotizacionesList(data.docs))
      .catch((e) => console.log(e));
  };

  const getPlanes = async () => {
    await axios
      .get(`${BACKEND}/api/planes?limit=0`)
      .then(({ data }) => setAllPlanesList(data.docs))
      .catch((e) => console.log(e));
  };

  const [puntosList, setPuntosList] = useState([]);

  const getCurrentPoints = async () => {
    if (data && data?.cliente) {
      await axios
        .get(
          `${BACKEND}/api/puntosServicioCliente?where[cliente][equals]=${data.cliente.id}&where[cotizacion][equals]=${dataDrawer.id}`
        )
        .then(({ data }) => setPuntosList(data.docs))
        .catch((e) => console.log(e));
    }
  };

  const getPagos = async () => {
    await axios
      .get(
        `${BACKEND}/api/pagosCotizaciones?where[cotizacion][equals]=${dataDrawer.id}&sort=createdAt&limit=1000`
      )
      .then(({ data }) => setPagosList(data.docs))
      .catch((e) => console.log(e));
  };

  const updatePagos = async () => {
    try {

      const updatePromises = pagosList.map(pago =>
        axios.patch(`${BACKEND}/api/pagosCotizaciones/${pago.id}`, {
          fechaLimite: null
        })
      )
  
      const responses = await Promise.all(updatePromises)

      const updatedPayments = responses.map(response => response.data.doc)
      
      setPagosList(updatedPayments)

      toast.info("Estado de cotización actualizado, actualiza las fechas límite de los pagos.")
    } catch (e) {
      console.log(e)
      toast.error("Error al actualizar los pagos")
    }
  }

  useEffect(() => {
    getServicios();
    getPlanes();
    getEmpresas()
  }, []);

  useEffect(() => {
    if (dataDrawer) getServiciosCotizaciones();
    if (dataDrawer) getCurrentPoints();
    if (dataDrawer) getPagos();
  }, [dataDrawer]);

  useEffect(() => {
    if (dataDrawer) setData(dataDrawer)

    if (dataDrawer?.responsableVenta) {
      setResponsableVenta(dataDrawer?.responsableVenta)
    }

    if (dataDrawer?.empresa) {
      setSelectedEmpresa(dataDrawer?.empresa)
    }

    if (dataDrawer?.comparativo) {
      setComparativo(true)
    } else {
      setComparativo(false)
    }

    if (dataDrawer?.comentario) {
      setComentario(dataDrawer?.comentario)
    } else {
      setComentario("")
    }

    if (dataDrawer?.primeraCotizacion) {
      setPrimeraCotizacion(true)
    } else {
      setPrimeraCotizacion(false)
    }

    if (dataDrawer?.marca) {
      setBrand(dataDrawer?.marca.id)
    } else {
      setBrand(null)
    }

    if (dataDrawer?.ultimaActualizacionSubestado) {
      setUltimaActualizacionSubestado(dataDrawer.ultimaActualizacionSubestado)
    }

    if (
      dataDrawer?.descuento &&
      dataDrawer?.precioDescuento &&
      dataDrawer?.tipoDescuento
    ) {
      setIsDescuento(true);
      setIsDescuentoOpen(true);
      setPrecioDescuento(dataDrawer?.precioDescuento);
      setTipoDescuento(dataDrawer?.tipoDescuento);
    } else {
      setIsDescuentoOpen(false);
      setPrecioDescuento(0);
    }
    if (dataDrawer) {
      setEstadoCotizacion(
        dataDrawer?.estado
          ? dataDrawer?.estado
          : dataDrawer?.totalPagado === dataDrawer.precioTotal
          ? "Exito"
          : "En espera"
      );
      setSubEstadoCotizacion(dataDrawer.subEstado)
      setTipoCotizacion(dataDrawer.tipo);

      if (dataDrawer?.igv) {
        setIgv(true);
      } else {
        setIgv(false);
      }

      // Inicializar campos de WhatsApp
      if (dataDrawer?.messageNote) {
        setMessageNote(dataDrawer.messageNote);
      } else {
        setMessageNote("");
      }

      if (dataDrawer?.fechaTentativaInicio) {
        setFechaTentativaInicio(new Date(dataDrawer.fechaTentativaInicio).toISOString().slice(0, 16));
      } else {
        setFechaTentativaInicio("");
      }
    }
  }, [dataDrawer]);

  if (!data) return;

  const itemsDataArray = [
    // { id: 1, title: "Pais", content: data?.cliente?.pais },
    { id: 2, title: "Nombre Gerente", content: data?.cliente?.nombreGerente },
    { id: 3, title: "Razón social", content: data?.cliente?.razonSocial },
    { id: 4, title: "Cumpleaños gerente",
      content: data?.cliente?.cumpleaniosGerente
        ? format(new Date(data.cliente.cumpleaniosGerente), "dd MMMM, yyyy", {locale: es})
        : "No registrado",
    },
    { id: 5, title: "RUC", content: data?.cliente?.ruc },
    { id: 6, title: "DNI", content: data?.cliente?.dni },
    { id: 7, title: "Teléfono Gerente", content: data?.cliente?.telefonoGerente },
    { id: 8, title: "Correo electrónico gerencia", content: data?.cliente?.emailGerencia },
    {
      id: 9,
      title: "Fecha Aniversario",
      content: data?.cliente?.fechaAniversario
        ? format(new Date(data.cliente?.fechaAniversario), "dd MMMM, yyyy", {locale: es})
        : "No registrado",
    },
    { id: 10, title: "Encargado del proyecto", content: data?.cliente?.encargadoProyecto },
    { id: 11, title: "Direccion", content: data?.cliente?.direccion },
    { id: 12, title: "N° empleados", content: data?.cliente?.nEmpleados },
    { id: 13, title: "Teléfono", content: data?.cliente?.telefono },
    { id: 14, title: "Rubro", content: data?.cliente?.nicho?.name },
    {
      id: 15,
      title: "Fecha cumpleaños",
      content: data?.cliente?.fechaCumpleanios
        ? format(new Date(data.cliente?.fechaCumpleanios), "dd MMMM, yyyy", {locale: es})
        : "No registrado",
    },
    { id: 16, title: "Ingresos anuales", content: data?.cliente?.ingresosAnuales },
    { id: 17, title: "Puesto de trabajo", content: data?.cliente?.puestoTrabajo },
  ];

  const saveAll = async () => {
    try {
      setLoading(true)

      if (puntosList.length > 0 && tipoCotizacion === "Factura") {
        await axios.put(`${BACKEND}/api/puntosServicioCliente/${puntosList[0].id}`, {
            puntos: getPuntosFromSelectedServicesandAllServices(
              allServiciosCotizacionesList,
              allServiciosList
            ),
          })
          .then(({ data }) => setPuntosList([data.doc]))
          .catch((e) => console.log(e));
      }

      // console.log("Guardando")
  
      if (estadoCotizacion === "Exito") {
        createProcessAsync()
      }
  
      await axios.patch(`${BACKEND}/api/cotizaciones/${dataDrawer?.id}`, {
        estado: estadoCotizacion,
        tipo: estadoCotizacion === "Exito" ? "Factura" : "Cotizacion",
        subEstado: subEstadoCotizacion || "Seleccionar",
        precioTotal: totalConIGV,
        precioTotalSinIGV: subtotalSinIGV,
        descuento: isDescuento,
        tipoDescuento: tipoDescuento,
        precioDescuento: precioDescuento,
        primeraCotizacion: primeraCotizacion,
        marca: brand,
        comentario: comentario,
        comparativo: comparativo,
        igv: igv,
        empresa: selectedEmpresa.id,
        ultimaActualizacionSubestado: ultimaActualizacionSubestado,
        responsableVenta: responsableVenta
      });

      // Guardar documentos si hay pendientes
      if (documentosRef.current?.guardarDocumentos) {
        await documentosRef.current.guardarDocumentos();
      }

      // Actualizar la cotizacion localmente
      // updateCotizacionLocally(response.data.doc);

      // Pruebas
      const dataDrawerResponse = await axios.get(`${BACKEND}/api/cotizaciones/${dataDrawer?.id}`)
      updateCotizacionLocally(dataDrawerResponse.data);
      setData(dataDrawerResponse.data)

      // Forzar actualización de servicios y contratos
      await getServiciosCotizaciones();

      toast.success("Cotización actualizada exitosamente")
      setLoading(false)
    } catch (e) {
      toast.error("Error al actualizar la cotizacion");
    } finally {
      setLoading(false)
    }
  }

  const updateCotizacionLocally = (updatedCot) => {
    setCotizacionesList((prevCotList) => {
      return prevCotList.map((cot) => {
        if (cot.id === updatedCot.id) {
          return { ...cot, ...updatedCot };
        } else {
          return cot;
        }
      });
    });
  };

  const updateFechaVentaLocally = (fechaVenta) => {
    setCotizacionesList((prevCotList) => {
      return prevCotList.map((cot) => {
        if (cot.id === data.id) {
          return { ...cot, fechaVenta };
        } else {
          return cot;
        }
      });
    });
  };

  const copyIdClipBoard = () => {
    navigator.clipboard.writeText(data.id);
    setIsCopiedId(true);
  };

  const closeDrawer = () => {
    onClose();
    setIsCopiedId(false);
  };

  const updateHistorical = async (newSubEstado) => {
    try {
      const arrayHistorical = dataDrawer.historialSubestado || []
      arrayHistorical.push({
        fecha: new Date().toISOString(),
        subestado: newSubEstado,
      })

      await axios.put(`${BACKEND}/api/cotizaciones/${dataDrawer.id}`, {
        historialSubestado: arrayHistorical
      })

      // toast.success("Historial de subestados actualizado correctamente")
    } catch (e) {
      return false
      //toast.error("Error al actualizar el historial de subestados")
    }
  }

  const createEventUpdateStatus = async (leadId, workerId, newStatus) => {
    try {
      await axios.post(`${BACKEND}/api/eventosLeads`, {
        lead: leadId,
        seller: workerId,
        eventType: "Cambio estado cotización",
        eventSubType: newStatus,
        leadStatus: newStatus === "Exito" ? "Cliente" : "Prospecto",
        title: "Subestado de cotización actualizado",
        description: `Substado de cotización actualizado en el sistema, evento creado automáticamente`,
        usuario: user.id,
        quote: dataDrawer.id
      })
      if (
        newStatus === "Evaluando opciones" || 
        newStatus === "Para el futuro" || 
        newStatus === "Frio" || 
        newStatus === "Por confirmar depósito"
      ) {
        ActualizarEstadoUsuario(leadId, "Prospecto")
      }
      if (newStatus === "Exito") {
        ActualizarEstadoUsuario(leadId, "Cliente")
      }
      toast.success("Evento de cambio de subestado de cotización creado correctamente")
    } catch (e) {
      return false
    }
  }

  const updateSpecificField = async (field, value) => {
    try {
      await axios.put(`${BACKEND}/api/cotizaciones/${data.id}`, {
        [field]: value
      })
    } catch (e) {
      console.log(e)
    }
  }

  const handleUpdateBrand = async (newBrandId) => {
    const previousBrandId = brand
    const normalizedBrandId = newBrandId === "" ? null : newBrandId

    // Optimistic UI: update selector immediately
    setBrand(normalizedBrandId)

    const selectedBrand = brands.find((b) => b.id === normalizedBrandId) || null

    try {
      await updateSpecificField("marca", normalizedBrandId)

      // Sync local detailed data and list item
      setData((prev) => ({ ...prev, marca: selectedBrand }))
      updateCotizacionLocally({ id: data.id, marca: selectedBrand })
    } catch (e) {
      // Revert on error
      setBrand(previousBrandId)
    }
  }

  const handleUpdateEmpresa = async (newEmpresaId) => {
    const previousEmpresa = selectedEmpresa
    const normalizedEmpresaId = newEmpresaId === "" ? null : newEmpresaId

    const empresaObj = empresas.find((emp) => emp.id === normalizedEmpresaId) || null

    // Optimistic UI: update selector immediately
    setSelectedEmpresa(empresaObj || {})

    try {
      await updateSpecificField("empresa", normalizedEmpresaId)

      // Sync local detailed data and list item
      setData((prev) => ({ ...prev, empresa: empresaObj }))
      updateCotizacionLocally({ id: data.id, empresa: empresaObj })
    } catch (e) {
      // Revert on error
      setSelectedEmpresa(previousEmpresa || {})
    }
  }

  const handleSaveWhatsappData = async () => {
    try {
      const updateData = {}
      
      if (messageNote !== undefined) {
        updateData.messageNote = messageNote
      }
      
      if (fechaTentativaInicio) {
        updateData.fechaTentativaInicio = new Date(fechaTentativaInicio).toISOString()
      } else {
        updateData.fechaTentativaInicio = null
      }

      await axios.put(`${BACKEND}/api/cotizaciones/${data.id}`, updateData)

      // Actualizar datos locales
      setData((prev) => ({
        ...prev,
        messageNote: messageNote,
        fechaTentativaInicio: fechaTentativaInicio ? new Date(fechaTentativaInicio).toISOString() : null
      }))
      
      updateCotizacionLocally({
        id: data.id,
        messageNote: messageNote,
        fechaTentativaInicio: fechaTentativaInicio ? new Date(fechaTentativaInicio).toISOString() : null
      })

      toast.success("Datos guardados exitosamente")
      setOpenWhatsappModal(false)
    } catch (e) {
      console.log(e)
      toast.error("Error al guardar los datos")
    }
  }

  // Validación: algún monto de montosServicios es 0, montosServicios vacío o longitud incorrecta
  const hasMontoServicioCero = pagosList.some(
    p => !p.montosServicios ||
      p.montosServicios.length === 0 ||
      p.montosServicios.length < allServiciosCotizacionesList.length
      //p.montosServicios.some(ms => ms.monto === 0)
  );

  // Validación: algún pago sin banco o cuenta
  const hasPagoSinBancoOCuenta = pagosList.some(
    pago => !pago.banco || !pago.cuenta
  );

  return (
    <DrawerRight
      open={open}
      maxWidth={"100%"}
      title={`✅ ${data?.cliente?.nombreComercial || data?.lead?.leadName} 🙋🏻‍♀️ Vendedor: ${data?.cotizador?.name}  🤑  Total: S/. ${data?.precioTotal.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 📁 Servicios: ${allServiciosCotizacionesList.map(servicio => servicio.servicio?.name).filter(Boolean).join(", ")}`}
      onClose={closeDrawer}
      disableOutsideClick={phoneDrawerOpen}
    >
      {/* Header */}
      <div className="flex flex-col sticky top-16 z-30">
        
        {/* Id de cot y fuente lead */}
        <div className="p-1 my-1 shadow-md flex flex-col justify-between items-center justify-center gap-4 border border-gray-200 rounded-md bg-white/60 backdrop-blur-md">

          {/* Fuente lead y tipo lead*/}
          <div className="flex flex-row gap-4 items-center justify-between w-full">

            {/* Fuente lead */}
            <div className="p-2 text-xs rounded-lg bg-white border">
              <dt className="font-bold text-xs leading-none text-gray-600">
                Fuente Lead:{" "}
                <span className="text-xs">{data.lead?.leadOrigin || data.fuenteLead} </span>
              </dt>
            </div>

            {/* Tipo cotizacion */}
            <div className="p-2 text-xs rounded-lg bg-white border">
              <dt className="font-bold text-xs leading-none text-gray-600">
                Tipo:{" "}
                <span className="text-xs">{data.tipo} </span>
              </dt>
            </div>

            {/* Id */}
            <div className="0 flex justify-start gap-2 items-center text-gray-700">
              <dt className="  text-xs leading-none  ">
                <strong>{data.id} </strong>
              </dt>
              {isCopiedId ? (
                <Tooltip
                  content={<div className=" text-xs text-green-600"> Copiado</div>}
                  theme="light"
                >
                  <div className=" bg-gray-50 rounded-sm p-2">
                    <FaCheck className=" text-green-500 w-5 h-5" />
                  </div>
                </Tooltip>
              ) : (
                <Tooltip
                  content={<div className=" text-xs">Copiar ID</div>}
                  theme="light"
                >
                  <div
                    onClick={copyIdClipBoard}
                    className=" cursor-pointer bg-gray-50 hover:bg-gray-100 rounded-md p-2"
                  >
                    <BsClipboard2Check className=" text-gray-700 w-5 h-5" />
                  </div>
                </Tooltip>
              )}
            </div>
            
            {/* Empresa */}
            <div className="flex flex-col justify-end h-full items-end">
              <div className="flex flex-row gap-2 items-center">
                <span className="text-xs font-bold">Empresa: </span>
                <select
                  id="subStateCot"
                  value={selectedEmpresa?.id || ""}
                  onChange={(e) => handleUpdateEmpresa(e.target.value)}
                  className="text-xs w-[200px] rounded-lg block p-2 bg-white border-gray-200 placeholder-gray-600 text-gray-700"
                >
                  <option value="">Seleccionar</option>
                  {empresas.map((empresa) => (
                    <option key={empresa.id} value={empresa.id}>
                      {empresa.razonSocial}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Marca seleccionada*/}
            <div className="flex flex-col gap-4 items-end">
              <div className="flex gap-2 justify-end items-center text-gray-700">
                {(() => {
                  const url = brands.find((b) => b.id === brand)?.image?.url
                  return (
                    url ? (
                        <img src={url} alt={brands.find((b) => b.id === brand)?.name || "Marca"} className="w-8"/>
                    ) : (
                      <div className="w-8">
                      </div>
                    )
                  )
                })()}
                <span className="text-xs font-bold">Marca: </span>
                <select
                  id="subStateCot"
                  value={brand}
                  onChange={(e) => handleUpdateBrand(e.target.value)}
                  className="text-xs rounded-lg block p-2 bg-white border-gray-200 placeholder-gray-600 text-gray-700"
                >
                  <option value={""}>Seleccionar</option>
                  {brands.map((b) => (
                    <option key={b.id} value={b.id}>{b.name}</option>
                  ))}
                </select>
              </div>
            </div>


          </div>
        
        </div>
        
        {/* Asesor comercial, cliente, estado cotizacion + tipo factura (compacto) */}
        <div className="sticky top-0 bg-slate-50/60 backdrop-blur-md p-3 border border-gray-200 rounded-md shadow-md">
          <div className="grid grid-cols-12 gap-3 items-center">

            {/* Primera fila: Asesor, Responsable de venta, Estado cotización y Subestado */}
            <div className="col-span-12 md:col-span-12 flex flex-wrap items-center justify-between gap-3">
              {/* Asesor */}
              <div className="col-span-12 md:col-span-3 flex items-center gap-2">
                <span className="text-[10px] font-semibold">Asesor:</span>
                {data?.cotizador?.foto ? (
                  <>
                    <img
                      alt="cotizador"
                      className="w-6 h-6 object-cover rounded-full"
                      src={data.cotizador.foto.url}
                    />
                    <span className="text-xs">{data.cotizador.name}</span>
                  </>
                ) : (
                  <span className="text-xs">{data.cotizador.name}</span>
                )}
              </div>
    
              {/* Responsable de venta */}
              <div className="flex items-center gap-2">
                <span className="text-[10px] font-semibold">Responsable:</span>
                <select 
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-md px-2 py-1"
                  value={responsableVenta}
                  onChange={(e) => setResponsableVenta(e.target.value)}
                >
                  <option value="No definido">No definido</option>
                  <option value="Area de ventas">Area de ventas</option>
                  <option value="Agencia">Agencia</option>
                </select>
              </div>
              
              {/* Estado cotización */}
              <div className="col-span-6 md:col-span-2">
                <div className="flex items-center gap-2">
                  <span className="text-[10px] font-semibold">Estado:</span>
                  <select
                    id="stateCot"
                    value={estadoCotizacion}
                    onChange={(e) => {
                      if (e.target.value === "Exito") {
                        setConvertToFacturaActive(true);
                        setSubEstadoCotizacion("Exito")
                        getInitialClientesWithQuery();
                      } else {
                        setConvertToFacturaActive(false);
                      }
                      updatePagos();
                      setEstadoCotizacion(e.target.value);
                    }}
                    className="text-xs rounded-md px-2 py-1 bg-white border border-gray-300 text-gray-700"
                  >
                    <option value="Exito">Exito</option>
                    <option value="En espera">En espera</option>
                    <option value="Perdido">Perdido</option>
                  </select>
                </div>
              </div>

              {/* Subestado */}
              <div className="col-span-6 md:col-span-4">
                <div className="flex items-center gap-2 min-w-[500px] max-w-[500px]">
                  <span className="text-[10px] font-semibold">Subestado:</span>
                  <select
                    id="subStateCot"
                    value={subEstadoCotizacion}
                    disabled={!isAdmin && estadoCotizacion === "Exito"}
                    onChange={(e) => {
                      setSubEstadoCotizacion(e.target.value);
                      setUltimaActualizacionSubestado(new Date().toISOString());
                      if (e.target.value !== "Seleccionar") {
                        createEventUpdateStatus(data.lead?.id, data.cotizador?.id, e.target.value)
                      }
                    }}
                    className="text-xs rounded-md px-2 py-1 bg-white border border-gray-300 text-gray-700 w-full"
                  >
                    {estadoCotizacion === "Exito" ? (
                      <>
                        <option value="Seleccionar">Seleccionar</option>
                        <option value="Exito">Exito</option>
                      </>
                    ) : estadoCotizacion === "En espera" ? (
                      <>
                        <option value="Seleccionar">Seleccionar</option>
                        <option value="Evaluando opciones">Evaluando opciones</option>
                        <option value="Para el futuro">Para el futuro</option>
                        <option value="Frio">Frio</option>
                        <option value="Por confirmar depósito">Por confirmar depósito</option>
                      </>
                    ) : estadoCotizacion === "Perdido" ? (
                      <>
                        <option value="Seleccionar">Seleccionar</option>
                        <option value="Curioso">Curioso</option>
                        <option value="No responde">No responde</option>
                        <option value="No esta en mi ciudad">No esta en mi ciudad</option>
                        <option value="El servicio le parece caro">El servicio le parece caro</option>
                        <option value="Decidió trabajar con otra agencia">Decidió trabajar con otra agencia</option>
                        <option value="Decidió trabajar con un freelancer">Decidió trabajar con un freelancer</option>
                        <option value="Competencia o sospech---oso">Competencia o sospechoso</option>
                        <option value="Lead con poco presupuesto">Lead con poco presupuesto</option>
                        <option value="Compro el servicio con otro usuario o otra cotizacion">Compro el servicio con otro usuario o otra cotizacion</option>
                      </>
                    ) : (
                      <option value="Seleccionar">Seleccionar</option>
                    )}
                  </select>
                </div>
              </div>
            </div>

            {/* Segunda fila: Responsable, Fecha venta, Primera cotización y Comentario */}
            <div className="col-span-12 md:col-span-12 flex flex-wrap items-center justify-between gap-3">
              {/* Cliente o Lead */}
              <div className="col-span-12 md:col-span-3 flex items-center gap-2">
                <span className="text-[10px] font-semibold">
                  {data.cliente ? "Cliente:" : data.lead ? "Lead:" : "Cliente:"}
                </span>
                <span className="text-xs">
                  {data.cliente ? data.cliente.nombreComercial : data.lead ? data.lead.leadName : "-"}
                </span>
              </div>

              {/* Fecha venta (solo Exito) */}
              {data.estado === "Exito" && (
                <div className="flex items-center gap-2">
                  <span className="text-[10px] font-semibold">Fecha venta:</span>
                  {isAdmin ? (
                    <input 
                      type="date" 
                      className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-md px-2 py-1"
                      value={data.fechaVenta ? new Date(data.fechaVenta).toISOString().split("T")[0] : ""}
                      onChange={(e) => {
                        HandleUpdateSelectSelf("fechaVenta", e.target.value, data.id, "cotizaciones", setData)
                        updateFechaVentaLocally(e.target.value)
                        if (debounceIncidencia.current) {
                          clearTimeout(debounceIncidencia.current);
                        }
                        debounceIncidencia.current = setTimeout(() => {
                          CrearIncidencia({
                            titulo: "Fecha de venta guardada erróneamente",
                            comentario: `Incidencia creada por sistema MC / 
                              Fecha de venta guardada erróneamente y debió ser actualizada por administración (${user.name}) /  
                              ID Cotización: ${data.id}`,
                            trabajador: data.cotizador.id,
                            descuento: 10
                          });
                          toast.success("Fecha de venta actualizada correctamente, incidencia creada");
                        }, 3000);
                      }}
                    />
                  ) : (
                    <span className="text-xs">
                      {data.fechaVenta ? FormatDateToDDMMYY(data.fechaVenta) : "-"}
                    </span>
                  )}
                </div>
              )}

              {/* Primera cotización */}
              <div className="flex items-center gap-2">
                <span className="text-[10px] font-semibold">¿Primera cotización?</span>
                <input
                  type="checkbox"
                  className="rounded-sm border-gray-400 hover:cursor-pointer"
                  checked={primeraCotizacion}
                  onChange={(e) => setPrimeraCotizacion(e.target.checked)}
                />
              </div>

              {/* Comentario - Ocupa el espacio restante */}
              <div className="flex items-center gap-2 flex-1 min-w-[200px] max-w-[500px]">
                <span className="text-[10px] font-semibold whitespace-nowrap">Comentario:</span>
                <textarea
                  rows={1}
                  className="text-xs rounded-md px-2 py-1 bg-white border border-gray-300 placeholder-gray-600 text-gray-700 resize-none flex-1 min-w-0"
                  value={comentario}
                  onChange={(e) => setComentario(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Si no hay cliente registrado y la cotizacion pasa a éxito, se pide que se registren los datos del cliente */}
      <div>
        {tipoCotizacion === "Cotizacion" &&
          convertToFacturaActive &&
          !data.cliente && (
            <div className="px-2 py-2 rounded-md bg-gray-200">
              <div className="flex justify-end pb-4">
                <div
                  onClick={() => {
                    setConvertToFacturaActive(false);
                    setEstadoCotizacion("En espera");
                  }}
                  className="p-2 bg-blue-50 rounded-lg cursor-pointer "
                >
                  <MdClose className=" text-blue-600" />
                </div>
              </div>

              <div className=" max-w-md mx-auto w-full">
                <NuevoClienteDialog
                  onSuccess={() => getInitialClientesWithQueryOnRefresh()}
                  open={createNewClientActive}
                  title={"Nuevo Cliente"}
                  onClose={() => setCreateNewClientActive(false)}
                  setClientPassword={setClientPassword}
                  setClientEmail={setClientEmail}
                />

                <div>
                  <div className=" mx-auto">
                    <h3 className=" text-gray-800 text-base pb-4 text-xs font-semibold">
                      Seleccionar un cliente
                    </h3>

                    <form
                      onSubmit={getSubmitClientes}
                      className=" pb-4 mx-auto"
                    >
                      <label
                        htmlFor="default-search"
                        className="mb-2 text-xs font-medium sr-only text-gray-700"
                      >
                        Search
                      </label>
                      <div className="relative max-w-md ">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                          <FaSearch className=" text-gray-600" />
                        </div>
                        <input
                          type="search"
                          id="default-search"
                          value={searchInputClientes}
                          onChange={(e) =>
                            setSearchInputClientes(e.target.value)
                          }
                          className="block w-full p-4 ps-10 text-xs  border 0 rounded-lg   bg-gray-100 border-gray-300 placeholder-gray-700 text-black "
                          placeholder="Buscar clientes "
                          required
                        />
                        <button
                          type="submit"
                          className="text-white absolute end-2.5 bottom-2.5 focus:ring-4 focus:outline-none font-medium rounded-lg text-xs px-4 py-2 bg-blue-600 hover:bg-blue-700 focus:ring-blue-800"
                        >
                          Buscar
                        </button>
                      </div>
                    </form>
                  </div>

                  <div className=" w-full   grid grid-cols-1 gap-2 md:grid-cols-2">
                    {allClientesUserList.map((e) => (
                      <button
                        onClick={() => setSelectedCliente(e)}
                        className={` ${
                          selectedCliente?.id === e.id
                            ? "bg-blue-500 text-white"
                            : "bg-white text-gray-700 hover:bg-blue-50"
                        } p-2 flex flex-col justify-start text-xs rounded-md  `}
                        key={e.id}
                      >
                        <span className=" text-base font-semibold text-xs ">
                          {" "}
                          {e.nombreComercial}
                        </span>
                        <span className=" text-xs font-light "> {e.email}</span>
                      </button>
                    ))}

                    {!createNewClientActive && (
                      <button
                        onClick={() => setCreateNewClientActive(true)}
                        type="button"
                        className=" px-2 py-3 flex flex-col justify-center items-center   rounded-md  text-white bg-blue-900 hover:bg-blue-800"
                      >
                        <FaPlusCircle />
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className=" pb-4 pt-10 flex justify-center">
                <button
                  type="button"
                  disabled={!selectedCliente}
                  onClick={convertToFactura}
                  className="text-white bg-[#4285F4] hover:bg-[#4285F4]/90 text-xs focus:ring-4 cursor-pointer focus:outline-none focus:ring-[#24292F]/50 font-medium rounded-lg px-5 py-2.5 text-center inline-flex gap-4 items-center focus:ring-gray-500  me-2 mb-2"
                >
                  Guardar estado y convertir a factura
                  <MdDocumentScanner className="w-6 h-6" />
                </button>
              </div>
            </div>
          )}
      </div>
      
      {/* Datos de la cotización */}
      <div className=" mt-4 mb-10">
        <dt className="mt-5 mb-2 font-semibold leading-none text-sm text-black">
          Cotización
        </dt>

        <div className="flex flex-col gap-2 sm:grid sm:grid-cols-2">

          <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
            <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
              Cotización válida hasta
            </dt>
            <dd className=" text-xs text-gray-600">
              {data?.fechaCotizacionLimite
                ? format(
                    new Date(data.fechaCotizacionLimite),
                    "dd MMMM, yyyy",
                    { locale: es }
                  )
                : "No registrado"}
            </dd>
          </div>
          
          <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
            <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
              {estadoCotizacion === "Exito" ? "N° Cotización" : "Teléfono"} 
            </dt>
            <dd className=" text-xs text-gray-600">{estadoCotizacion === "Exito" ? data.numeroCotizacion : data.lead?.phone}</dd>
          </div>

        </div>

        {estadoCotizacion !== "Exito" && (
          <div className="flex flex-col mt-4 gap-2 sm:grid sm:grid-cols-2">

            <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
              <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
                DNI
              </dt>
              <dd className=" text-xs text-gray-600">{data.lead?.dni || data?.leadDNI}</dd>
            </div>

            <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
              <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
                RUC
              </dt>
              <dd className=" text-xs text-gray-600">{data.lead?.ruc || data.leadRUC}</dd>
            </div>
            
          </div>
        )}

        {estadoCotizacion !== "Exito" && (
          <div className="flex flex-col mt-4 gap-2 sm:grid sm:grid-cols-2">
            <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
              <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
                Nombres
              </dt>
              <dd className=" text-xs text-gray-600">{data.lead?.leadName || data?.leadNombre}</dd>
            </div>

            <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
              <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
                Nombre Legal
              </dt>
              <dd className=" text-xs text-gray-600">{data.lead?.brandName || data?.leadCompany}</dd>
            </div>
          </div>
        )}

        <div className="flex flex-col mt-4 gap-2 sm:grid sm:grid-cols-2">
          <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
            <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
              País
            </dt>
            <div className="flex flex-row items-center gap-2">
              <dd className="text-xs text-gray-600">{data.cliente?.pais || data?.lead?.country}</dd>
              {flagUrl && (
                <img src={flagUrl} alt="Flag" className="w-4 h-4" />
              )}
            </div>
          </div>
        </div>

      </div>

      {/* Datos Cliente */}
      {data?.cliente && (
        <div>
          <dt className="mt-5 mb-2 font-semibold leading-none text-sm text-black">
            Datos Generales del cliente
          </dt>
          <div className=" flex flex-col gap-2 sm:grid sm:grid-cols-2 md:grid md:grid-cols-3 ">
            {itemsDataArray?.map((e) => (
              <Item title={e.title} key={e.id}>
                {e.content}
              </Item>
            ))}
          </div>
        </div>
      )}

      <hr className="mt-8 mb-8"/>

      {/* Agregar servicios */}
      <div>
        <div className="flex flex-row justify-between items-center">
          <h1 className="font-semibold leading-none text-sm text-black">
            Servicios de interés
          </h1>
          {!openAddServicio && !openGenerarCotizacionHyD && (
            <div className="flex justify-center gap-4 overflow-x-auto py-1">

              <Button // Modo hosting y dominios
                variant="contained"
                endIcon={<CloudIcon fontSize="small" />}
                sx={{
                  fontSize: "11px",
                  fontWeight: "bold", 
                  fontFamily: "poppins",
                  padding: "4px 16px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  width: "180px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => setOpenGenerarCotizacionHyD(true)}
              >
                Hosting y dominios
              </Button>

              <Button // Agregar servicio
                variant="contained"
                endIcon={<AddIcon />}
                sx={{
                  fontSize: "11px",
                  fontWeight: "bold", 
                  fontFamily: "poppins",
                  padding: "4px 16px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  width: "180px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => setOpenAddServicio(true)}
              >
                Agregar Servicio
              </Button>

            </div>
          )}
        </div>

        <AutogenerarCotizacionHyD
          open={openGenerarCotizacionHyD}
          onClose={() => setOpenGenerarCotizacionHyD(false)}
          idCotizacion={data?.id}
          setPagos={setPagosList}
          setServicios={setAllServiciosCotizacionesList}
          fechaInicio={data?.fechaVenta}
          onSubmit={() => setOpenGenerarCotizacionHyD(false)}
        />

        <AgregarServicio
          idCotizacion={data?.id}
          moneda={data.moneda}
          idCliente={data?.cliente?.id}
          planes={allPlanesList}
          allServiciosCotizacionesList={allServiciosCotizacionesList}
          setAllServiciosCotizacionesList={setAllServiciosCotizacionesList}
          servicios={allServiciosList}
          open={openAddServicio}
          onClose={() => setOpenAddServicio(false)}
        />

      </div>
      
      {/* Lista de servicios */}
      <div className="relative overflow-x-auto">
        <table className="w-full text-xs text-left rtl:text-right text-gray-500">
          <thead className="text-[10px] text-gray-700 bg-slate-100">
            <tr>
              {isAdmin && (
                <th scope="col" className="px-6 py-2"></th>
              )}
              <th scope="col" className="px-6 py-3 sticky z-20 left-0 bg-slate-100 min-w-[60px] w-[60px] max-w-[60px]">
                <Tooltip content="Guardar">
                  <div className="flex pl-1">
                    <FaSave className="text-[10px]" />
                  </div>
                </Tooltip>
              </th>
              <th scope="col" className="px-6 py-2">
                ID
              </th>
              {estadoCotizacion === "Exito" && (
                <th scope="col" className="px-6 py-2">
                  Requiere prod. audiovisual
                </th>
              )}
              <th scope="col" className="px-6 py-2 whitespace-nowrap sticky z-20 left-[60px] bg-slate-100 min-w-[60px] w-[60px] max-w-[60px]">
                <Tooltip content="Confirmaciones">
                  <div className="flex">
                    <FaExclamationTriangle className="text-xs" />
                  </div>
                </Tooltip>
              </th>
              <th scope="col" className="px-6 py-2 sticky z-20 left-[120px] bg-slate-100 min-w-[60px] w-[60px] max-w-[60px]">
                <Tooltip content="Operaciones de venta">
                  <div className="flex">
                    <FaWrench className="text-xs" />
                  </div>
                </Tooltip>
              </th>
              <th scope="col" className="px-6 py-2 sticky z-20 left-[180px] bg-slate-100 min-w-[100px] w-[100px] max-w-[100px] whitespace-nowrap">
                Editar {<br />} Descripción
              </th>
              <th scope="col" className="px-6 py-2">
                Cuenta comercial o publicitaria
              </th>
              <th scope="col" className="px-6 py-2 sticky z-20 left-[280px] bg-slate-100 min-w-[240px]">
                Servicio
              </th>
              <th scope="col" className="px-6 py-2">
                Plan
              </th>
              <th scope="col" className="px-6 py-2">
                Comentario vendedor
              </th>
              {/* <th scope="col" className="px-6 py-2">
                Variables del servicio
              </th> */}
              <th scope="col" className="px-6 py-2">
                Audios
              </th>
              <th scope="col" className="px-6 py-2">
                Cantidad/<br />Meses
              </th>
              <th scope="col" className="px-6 py-2">
                Precio Unitario (PEN)
              </th>
              <th scope="col" className="px-6 py-2 whitespace-nowrap text-ellipsis">
                Editar <br /> Precio unitario
              </th>
              <th scope="col" className="px-6 py-2">
                Tipo descuento unitario
              </th>
              <th scope="col" className="px-6 py-2">
                Monto descuento unitario
              </th>
              <th scope="col" className="px-6 py-2">
                Subtotal untiario
              </th>
              <th scope="col" className="px-6 py-2">
                Subtotal
              </th>
              <th scope="col" className="px-6 py-2">
                IGV
              </th>
              <th scope="col" className="px-6 py-2">
                Monto IGV unitario
              </th>
              <th scope="col" className="px-6 py-2">
                Monto IGV total
              </th>
              {allowUniquePayment && (
                <th scope="col" className="px-6 py-2">
                  Pago único
                </th>
              )}
              <th scope="col" className="px-6 py-2">
                Servicio gratuito (regalo)
              </th>
              <th scope="col" className="px-6 py-2 w-56">
                Fecha Tentativa Inicio
              </th>
              <th scope="col" className="px-6 py-2">
                Fecha Tentativa Fin
              </th>
              <th scope="col" className="px-6 py-2 sticky z-20 right-0 bg-slate-100">
                Precio <br /> venta <br /> unitario
              </th>
              <th scope="col" className="px-6 py-2">
                Previo venta final
              </th>
            </tr>
          </thead>
          <tbody>
            {allServiciosCotizacionesList.map((e) => (
              <ItemRowServicioCotizacion
                key={e.id}
                data={e}
                tipoCotizacion={tipoCotizacion}
                servicios={allServiciosList}
                allServiciosCotizacionesList={allServiciosCotizacionesList}
                setAllServiciosCotizacionesList={
                  setAllServiciosCotizacionesList
                }
                planes={allPlanesList}
                pagos={pagosList}
                isAdmin={isAdmin}
                paises={paises}
                allowUniquePayment={allowUniquePayment}
              />
            ))}
          </tbody>
        </table>  
      </div>

      {/* Total */} 
      <div className="flex flex-col justify-end">

        {/* Subtotal sin IGV */}
        <div className="flex justify-end">
          <div className="bg-gray-50 shadow-md text-black p-2 text-sm">
            Subtotal:{" "}
            <strong> {"PEN"} {subtotalSinIGV.toFixed(2)}</strong>
          </div>
        </div>

        {/* Total IGV */}
        <div className="flex justify-end">
          <div className="bg-gray-50 shadow-md text-black p-2 text-sm">
            Monto IGV total:{" "}
            <strong>{"PEN"} {igvTotal.toFixed(2)}</strong>
          </div>
        </div>

        {/* Total con IGV y descuento */}
        <div className="flex justify-end">
          <div className="bg-gray-50 shadow-md text-black p-2 text-sm">
            Total:{" "}
            <strong>{"PEN"} {(totalConIGV).toFixed(2)}</strong>
          </div>
        </div>

      </div>

      {/* Transaccions si es Factura */}
      {tipoCotizacion === "Factura" && (
        <div className="mt-12 mb-6">
          {pagosList.length > 0 && (
            <h1 className="mt-5 mb-2 font-semibold leading-none text-sm text-black">
              Transacciones
            </h1>
          )}

          {pagosList && pagosList.length > 0 && (
            <div className="flex flex-col gap-4">
              <div className="border-t border-gray-500 pt-2 grid grid-cols-1 md:grid-cols-4 gap-2">
                <ItemTransaccion title={"Moneda"}>
                  {data.moneda}
                </ItemTransaccion>
                <ItemTransaccion title={"Cantidad adelanto reserva"}>
                  S/. {pagosList[0].precio.toFixed(2)}
                </ItemTransaccion>
                <ItemTransaccion title={"Fecha limite"}>
                  {pagosList[0].fechaLimite &&
                    format(
                      new Date(pagosList[0].fechaLimite),
                      "dd MMMM, yyyy",
                      { locale: es }
                    )}
                </ItemTransaccion>
              </div>

              <div className="border-t border-gray-500 pt-2 grid grid-cols-1 md:grid-cols-4 gap-2">

                <ItemTransaccion title={"Cantidad pagado"}>
                  S/. {pagosList.filter((p) => p.pagado).reduce((acc, obj) => acc + obj?.precio, 0).toFixed(2)}
                </ItemTransaccion>
                <ItemTransaccion title={"Porcentaje pagado"}>
                  {(pagosList.filter((p) => p.pagado).reduce((acc, obj) => acc + (obj.precio / totalConIGV * 100), 0).toFixed(2))}%
                </ItemTransaccion>
                <ItemTransaccion title={"Cuotas"}>
                  {pagosList.filter((p) => p.pagado).length}
                </ItemTransaccion>
              </div>

              <div className=" border-b border-t border-gray-500 py-2 grid grid-cols-1 md:grid-cols-4 gap-2">
                <ItemTransaccion title={"Cantidad Deuda"}>
                  S/. {(pagosList.filter((p) => !p.pagado).reduce((acc, obj) => acc + (obj.precio), 0).toFixed(2))}
                </ItemTransaccion>
                <ItemTransaccion title={"Porcentaje deuda"}>
                  {(pagosList.filter((p) => !p.pagado).reduce((acc, obj) => acc + (obj.precio / totalConIGV * 100), 0).toFixed(2))}%
                </ItemTransaccion>
                <ItemTransaccion title={"Cuotas"}>
                  {pagosList.filter((p) => !p.pagado).length}
                </ItemTransaccion>
              </div>
            </div>
          )}
        </div>
      )}

      <hr className="mt-8 mb-8"/>

      {/* Pago */}
      <div className="">

        <div className="flex flex-row justify-between items-center py-1">
          <h1 className="font-semibold leading-none text-sm text-black">
            Condiciones de pago
          </h1>
          {isAdmin && (
            <Button // Agregar múltiples pagos
              variant="contained"
              endIcon={<HistoryIcon />}
              sx={{
                fontSize: "11px",
                fontWeight: "bold", 
                fontFamily: "poppins",
                padding: "4px 16px",
                backgroundColor: "#ff6400",
                transform: "all",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                width: "230px",
                '&:hover': {
                  backgroundColor: "#bb4a03",
                }
              }}
              onClick={() => setOpenHistorialCambiosPagos(true)}
            >
              Historial de cambios
            </Button>
          )}

          {!openAddPago && !openAddMultiplesPagos && (
            <div className="flex justify-center gap-4 overflow-x-auto py-1">

              <Button // Agregar múltiples pagos
                variant="contained"
                endIcon={<PaymentsIcon />}
                sx={{
                  fontSize: "11px",
                  fontWeight: "bold", 
                  fontFamily: "poppins",
                  padding: "4px 16px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  width: "230px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => setOpenAddMultiplesPagos(true)}
              >
                Agregar múltiples pagos
              </Button>

              <Button // Agregar pago
                variant="contained"
                endIcon={<AddIcon />}
                sx={{
                  fontSize: "11px",
                  fontWeight: "bold", 
                  fontFamily: "poppins",
                  padding: "4px 16px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  width: "140px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => setOpenAddPago(true)}
              >
                Agregar Pago
              </Button>

            </div>
          )}

        </div>

        <AgregarMultiplesPagos
          idCotizacion={data?.id}
          moneda={currency}
          servicios={allServiciosCotizacionesList}
          precioTotal={totalConIGV}
          pagosList={pagosList}
          setPagosList={setPagosList}
          open={openAddMultiplesPagos}
          onClose={() => setOpenAddMultiplesPagos(false)}
        />

        <AgregarPago
          idCotizacion={data?.id}
          moneda={currency}
          precioTotal={totalConIGV}
          pagosList={pagosList}
          setPagosList={setPagosList}
          open={openAddPago}
          onClose={() => setOpenAddPago(false)}
        />
      </div>

      {/* Lista de pagos */}
      <div className="relative overflow-x-auto overflow-y-auto max-h-[800px] mb-4">
        <table className="w-full text-xs text-left rtl:text-right text-gray-400">
          <thead className="text-xs text-gray-700 bg-slate-100 sticky top-0">
            <tr>
              {isAdmin && (
                <th scope="col" className="px-6 py-2"></th>
              )}
              <th scope="col" className="px-6 py-3 sticky z-[5] left-0 bg-slate-100 min-w-[60px] w-[60px] max-w-[60px]">
                <Tooltip content="Guardar">
                  <div className="flex pl-1">
                    <FaSave className="text-[10px]" />
                  </div>
                </Tooltip>
              </th>
              <th scope="col" className="px-6 py-3">
                ID
              </th>
              <th scope="col" className="px-6 py-3">
                Moneda
              </th>
              <th scope="col" className="px-6 py-3 sticky z-[5] bg-slate-100 left-[60px]" style={{ minWidth: '100px', width: '100px' }}>
                N° de pago
              </th>
              <th scope="col" className="px-6 py-3 sticky z-[5] bg-slate-100 left-[160px]" style={{ minWidth: '500px', width: '500px' }}>
                <span className="flex flex-row items-center justify-center gap-4">
                  Distribución por servicio
                  <Tooltip content="Muestra cómo se distribuye el pago entre los diferentes servicios. Cada servicio puede tener un monto específico y puede incluir o no IGV.">
                    <div className="bg-black text-white rounded-full p-0.5 text-[10px]">
                      <FaQuestion />
                    </div>
                  </Tooltip>
                </span>
              </th>
              <th scope="col" className="px-6 py-3 sticky z-[5] bg-slate-100 left-[660px] whitespace-nowrap" style={{ minWidth: '150px', width: '150px' }}>
                Precio total
              </th>
              {NormalizeText(dataDrawer?.cliente?.pais || dataDrawer?.lead?.country) !== NormalizeText("Perú") && (
                <th scope="col" className="px-6 py-3">
                  Monto tipo de cambio
                </th>
              )}
              <th scope="col" className="px-6 py-3">
                Porcentaje
              </th>
              <th scope="col" className="px-6 py-3 w-56">
                <span className="flex flex-row items-center justify-center gap-4">
                  Fecha limite
                  <Tooltip content="Fecha en la que se prevee que el cliente realize el pago.">
                    <div className="bg-black text-white rounded-full p-0.5 text-[10px]">
                      <FaQuestion />
                    </div>
                  </Tooltip>
                </span>
              </th>
              <th scope="col" className="px-6 py-3 w-56">
                <span className="flex flex-row items-center justify-center gap-4">
                  Fecha pago
                  <Tooltip content="Fecha en que el cliente realizó el pago.">
                    <div className="bg-black text-white rounded-full p-0.5 text-[10px]">
                      <FaQuestion />
                    </div>
                  </Tooltip>
                </span>
              </th>
              <th scope="col" className="px-6 py-3 ">
                Banco
              </th>
              <th scope="col" className="px-6 py-3 ">
                Cuenta
              </th>
              <th scope="col" className="px-6 py-3 ">
                Pagado
              </th>
              <th scope="col" className="px-6 py-3 ">
                Imagen del pago
              </th>
              <th scope="col" className="px-6 py-3 ">
                Pago verificado
              </th>
              <th scope="col" className="px-6 py-3 ">
                Faltó al compromiso de pago
              </th>
              {hostingDomainCot && (
                <>
                  <th scope="col" className="px-6 py-3 ">
                    Agencia compró hosting
                  </th>
                  <th scope="col" className="px-6 py-3 ">
                    Agencia compró dominio
                  </th>
                  <th scope="col" className="px-6 py-3 ">
                    Agencia imagen compra dominio
                  </th>
                </>
              )}
              <th scope="col" className="px-6 py-3 ">
                Notas
              </th>
            </tr>
          </thead>
          <tbody>
            {pagosList.map((pago) => (
              <ItemRowPagoCotizacion
                key={pago.id}
                setPagosList={setPagosList}
                pagosList={pagosList}
                serviciosList={allServiciosCotizacionesList}
                data={pago}
                moneda={data.moneda}
                totalPrice={totalConIGV}
                isAdmin={isAdmin}
                currencyExchange={currencyExchange}
                currency={currency}
                hostingDomainCot={hostingDomainCot}
              />
            ))}

            {pagosList.length > 0 && (
              <tr className="">
                {isAdmin && (
                  <td className="px-6 py-4"></td>
                )}
                <td className="px-6 py-4 bg-white sticky left-0 z-[5] min-w-[60px] w-[60px]"></td>
                <td className="px-6 py-4"></td>
                <td className="px-6 py-4"></td>
                <td className="px-6 py-4 bg-white sticky z-[5] left-[60px]" style={{ minWidth: '100px', width: '100px' }}></td>
                <td className="px-6 py-4 bg-white sticky z-[5] left-[160px]" style={{ minWidth: '500px', width: '500px' }}></td>
                <td className="px-6 py-4 bg-white sticky z-[5] left-[660px]" style={{ minWidth: '150px', width: '150px' }}>
                  {" "}
                  <div
                    className={`  ${
                      pagosList.reduce((acc, obj) => acc + obj.precio, 0) ===
                        getFinalPriceCotDrawer(serviciosList, 0) &&
                      "text-green-400  flex justify-start gap-2 items-center"
                    }`}
                  >
                    {pagosList.reduce((acc, obj) => acc + obj.precio, 0) ===
                      getFinalPriceCotDrawer(serviciosList, 0) && (
                      <div>
                        <FaCheckCircle />
                      </div>
                    )}
                    <span>
                      {"S/."} {(pagosList.reduce((acc, obj) => acc + obj.precio, 0).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }))}
                    </span>
                  </div>
                </td>
                {NormalizeText(dataDrawer?.cliente?.pais || dataDrawer?.lead?.country) !== NormalizeText("Perú") && (
                  <td className="px-6 py-4">
                    <span className="whitespace-nowrap">
                      {(pagosList.reduce((acc, obj) => acc + obj.precio, 0) / currencyExchange).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {currency}
                    </span>
                  </td>
                )}
                <td className="px-6 py-4">
                  {" "}
                  <span>
                    {(pagosList.reduce((acc, obj) => acc + (obj.precio / totalConIGV * 100), 0).toFixed(2))}%
                  </span>
                </td>
                <td colSpan={hostingDomainCot ? 12 : 9}></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <CallSection 
        calls={registrosLlamadas} 
        refetch={getRegistrosLlamadas} 
        clientData={dataDrawer?.cliente} 
        quoteId={dataDrawer?.id}
        isDrawer={true}
      />

      {/* Documentos */}
      <div className="flex flex-col gap-4">
        <span className="font-semibold leading-none text-sm text-black">Documentos</span>
        <DocumentosCotizacion 
          ref={documentosRef}
          cotizacionId={dataDrawer?.id} 
          docuemntoFirmadoInicial={dataDrawer?.documentoFirmado || dataDrawer?.documentofirmado}
          documentos={dataDrawer?.documentos}
          documentoContrato={dataDrawer?.documentoContrato}
          pdfContrato={dataDrawer?.pdfContrato}
          isAdmin={isAdmin}
          updateCotizacionLocally={updateCotizacionLocally}
        />
      </div>

      {/* Acciones y Guardar */}
      <div className="sticky bottom-0 z-[100] mt-20">
        <div className="bg-slate-50/60 backdrop-blur-md p-4 border border-gray-200 rounded-md shadow-md relative">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            
            {/* Opciones de acción */}
            <div className="flex flex-row flex-wrap justify-center items-center gap-3">
              <Tooltip content={signedContractUrl ? "Revisar contrato firmado por el cliente" : "No hay contrato firmado por el cliente"}>
                <button
                  onClick={() => signedContractUrl && window.open(signedContractUrl, '_blank')}
                  disabled={!signedContractUrl}
                  className={`${signedContractUrl ? 'cursor-pointer hover:bg-gray-200' : 'opacity-50 cursor-not-allowed'} bg-white text-gray-700 border border-gray-300 hover:border-gray-400 p-2 rounded-md transition duration-200`}
                >
                  <FaRegFilePdf className="w-4 h-4" />
                </button>
              </Tooltip>
              
              <Tooltip content="Generar contrato">
                <button
                  onClick={() => {
                    const currentAgencyName = data?.marca?.name || brands.find(b => b.id === brand)?.name || "Monstruo Creativo"
                    const templatePath = `/docs/Contratos/Contrato ${currentAgencyName}.docx`
                    GenerateContract({ 
                      services: allServiciosCotizacionesList, 
                      quote: data, 
                      payments: pagosList, 
                      location: templatePath 
                    })
                  }}
                  className="cursor-pointer bg-white text-gray-700 border border-gray-300 hover:bg-gray-200 hover:border-gray-400 p-2 rounded-md transition duration-200"
                >
                  <FaFileContract className="w-4 h-4" />
                </button>
              </Tooltip>

              <Tooltip content={hasPaymentsWithoutDueDate ? "Debes actualizar las fechas límite de los pagos para exportar el PDF" : "Exportar PDF"}>
                <button
                  onClick={() => !hasPaymentsWithoutDueDate && setPdfOpen(true)}
                  disabled={hasPaymentsWithoutDueDate}
                  className={`${hasPaymentsWithoutDueDate ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-gray-200'} bg-white text-gray-700 border border-gray-300 hover:border-gray-400 p-2 rounded-md transition duration-200`}
                >
                  <FaRegFilePdf className="w-4 h-4" />
                </button>
              </Tooltip>

              {tipoCotizacion === "Factura" &&
                allServiciosCotizacionesList.length > 0 && (
                  <Tooltip content="Renovar servicios">
                    <button
                      onClick={() => setOpenRenewCot(true)}
                      className="cursor-pointer bg-white text-gray-700 border border-gray-300 hover:bg-gray-200 hover:border-gray-400 p-2 rounded-md transition duration-200"
                    >
                      <MdAutorenew className="w-4 h-4" />
                    </button>
                  </Tooltip>
              )}

              {brand === "67ea9c110e2642a4b0b902e1" && (
                <Tooltip content="Activar modo comparativo: Se desglosarán los servicios y los planes seleccinados, colocandolos en una tabla comprarativa para que el cliente pueda ver las ventajas y opciones de cada plan">
                  <button
                    onClick={() => setComparativo(!comparativo)}
                    className={`cursor-pointer p-2 rounded-md transition-all duration-200 border ${
                      comparativo 
                        ? "bg-gray-700 text-white border-gray-700" 
                        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-200 hover:border-gray-400"
                    }`}
                  >
                    <MdCompareArrows className="w-4 h-4" />
                  </button>
                </Tooltip>
              )}

              <Tooltip content="Activar modo incógnito: Reduce la cantidad de servicios a 1, elimina la tabla pagos de la cotización. Esto solo modifica como se ve el PDF y no los datos de la cotización.">
                <button
                  onClick={() => setIncognitMode(!incognitMode)}
                  className={`cursor-pointer p-2 rounded-md transition-all duration-200 border ${
                    incognitMode 
                      ? "bg-gray-700 text-white border-gray-700" 
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-200 hover:border-gray-400"
                  }`}
                >
                  <FaTeamspeak className="w-4 h-4" />
                </button>
              </Tooltip>

              <Tooltip content="Transferir cotización a otro vendedor">
                <button
                  onClick={() => setOPenTransferirCoti(true)}
                  className="cursor-pointer bg-white text-gray-700 border border-gray-300 hover:bg-gray-200 hover:border-gray-400 p-2 rounded-md transition duration-200"
                >
                  <RiFolderTransferLine className="w-4 h-4" />
                </button>
              </Tooltip>

              <Tooltip content="Speech de venta">
                <button
                  onClick={() => setOpenSpeechModal(true)}
                  className="cursor-pointer bg-white text-gray-700 border border-gray-300 hover:bg-gray-200 hover:border-gray-400 p-2 rounded-md transition duration-200"
                >
                  <FaMicrophone className="w-4 h-4" />
                </button>
              </Tooltip>

              <Tooltip content="Datos para el grupo de whatsapp">
                <button
                  onClick={() => {
                    setMessageNote(data?.messageNote || "")
                    setFechaTentativaInicio(
                      data?.fechaTentativaInicio 
                        ? new Date(data.fechaTentativaInicio).toISOString().slice(0, 16)
                        : ""
                    )
                    setOpenWhatsappModal(true)
                  }}
                  className="cursor-pointer bg-white text-gray-700 border border-gray-300 hover:bg-gray-200 hover:border-gray-400 p-2 rounded-md transition duration-200"
                >
                  <FaWhatsapp className="w-4 h-4" />
                </button>
              </Tooltip>

              <Tooltip content="Cerrar">
                <button
                  onClick={onClose}
                  className="cursor-pointer bg-white text-gray-700 border border-gray-300 hover:bg-gray-200 hover:border-gray-400 p-2 rounded-md transition duration-200"
                >
                  <MdClose className="w-4 h-4" />
                </button>
              </Tooltip>
            </div>

            {/* Botón Guardar */}
            <div className="flex items-center justify-center">
              {(() => {
                // Validar campos de WhatsApp
                const currentMessageNote = messageNote || data?.messageNote || ""
                const currentFechaTentativaInicio = fechaTentativaInicio || (data?.fechaTentativaInicio ? new Date(data.fechaTentativaInicio).toISOString().slice(0, 16) : "")
                const missingWhatsappFields = !currentMessageNote.trim() || !currentFechaTentativaInicio

                // Validaciones
                const validations = {
                  noPayments: pagosList.length === 0,
                  invalidTotal: Math.abs(pagosList.reduce((acc, obj) => acc + obj.precio, 0) - totalConIGV) > 3,
                  noSubState: !subEstadoCotizacion || subEstadoCotizacion === "Seleccionar",
                  noBrand: !brand,
                  noClientForInvoice: convertToFacturaActive && !data.cliente,
                  hasPaymentsWithoutDueDate,
                  hasMontoServicioCero,
                  hasPagoSinBancoOCuenta,
                  missingWhatsappFields
                };

                // Mensaje de error
                const errorMessage = 
                  validations.noPayments ? "Debes registrar los pagos para poder guardar la cotización." :
                  validations.invalidTotal ? "La suma total de los pagos debe ser igual al monto total de la cotización." :
                  validations.noSubState ? "Debes seleccionar un sub estado para la cotización." :
                  validations.noBrand ? "Debes seleccionar una marca para la cotización." :
                  validations.noClientForInvoice ? "Debes seleccionar un cliente para convertir a factura." :
                  validations.hasPaymentsWithoutDueDate ? "Debes actualizar las fechas límite de los pagos." :
                  validations.hasMontoServicioCero ? "Los montos por servicio no están correctamente configurados." :
                  validations.hasPagoSinBancoOCuenta ? "Todos los pagos deben tener banco y cuenta seleccionados." :
                  validations.missingWhatsappFields ? "Debes completar las notas adicionales y la fecha tentativa de inicio para el grupo de WhatsApp." :
                  "";

                // Verificar si hay alguna validación que falle
                const hasValidationError = Object.values(validations).some(value => value);

                return hasValidationError ? (
                  <Tooltip content={errorMessage}>
                    <div>
                      <DinamicButton 
                        content="Guardar"
                        backgroundColor="#6b7280"
                        disabledBackgroundColor="#d1d5db"
                        hoverBackgroundColor="#4b5563"
                        disabled
                        fontSize="12px"
                        width="200px"
                      />
                    </div>
                  </Tooltip>
                ) : (
                  <DinamicButton 
                    content="Guardar" 
                    action={saveAll} 
                    backgroundColor="#ff6400"
                    hoverBackgroundColor="#bb4a03"
                    disabled={loading} 
                    fontSize="12px"
                    width="200px"
                    icon={loading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />} 
                  />
                );
              })()}
            </div>
          </div>
        </div>
      </div>

      <TransferirCotizacionDialog
        data={data}
        tipoDescuento={tipoDescuento}
        updateCotizacionLocally={updateCotizacionLocally}
        open={openTransferirCoti}
        onClose={() => setOPenTransferirCoti(false)} 
      />

      <HistorialCambiosPagos
        open={openHistorialCambiosPagos}
        onClose={() => setOpenHistorialCambiosPagos(false)}
        data={data.historialCambiosPagos ? [...data.historialCambiosPagos].reverse() : []}
      />

      <RenovarCotiDialog
        open={openRenewCot}
        onClose={() => setOpenRenewCot(false)}
        serviciosList={allServiciosCotizacionesList}
        pagoList={pagosList}
        data={data}
        cotizacionesList={cotizacionesList}
        setCotizacionesList={setCotizacionesList}
      />

      {SelectedPDFComponent && (
        <SelectedPDFComponent
          igv={igv}
          moneda={currency}
          tipoCambio={currencyExchange}
          comparativo={comparativo}
          incognitMode={incognitMode}
          paises={paises}
          descuento={
            isDescuento
              ? tipoDescuento === "fijo"
                ? precioDescuento
                : (getFinalPriceCotDrawer(
                    allServiciosCotizacionesList,
                    0,
                    allServiciosList
                  ) *
                  precioDescuento) / 100
              : 0
          }
          open={pdfOpen}
          allServiciosList={allServiciosList}
          pagosList={pagosList}
          serviciosList={allServiciosCotizacionesList}
          cotizacionData={data}
          onClose={() => setPdfOpen(false)}
          title={"Vista Previa PDF"}
        />
      )}
      <SpeechModal activeModal={openSpeechModal} onClose={() => setOpenSpeechModal(false)} cotizacion={dataDrawer} serviciosCotizaciones={allServiciosCotizacionesList} pagos={pagosList} igv={igv}/>
      
      <ModalInDrawer
        activeModal={openWhatsappModal}
        onClose={() => setOpenWhatsappModal(false)}
        title="Notas grupo de WhatsApp"
        className="max-w-4xl"
        centered
        footerContent={
          <div className="flex gap-2">
            <button
              onClick={() => setOpenWhatsappModal(false)}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition duration-200"
            >
              {data?.sentToGroup ? 'Cerrar' : 'Cancelar'}
            </button>
            {!data?.sentToGroup && (
              <button
                onClick={handleSaveWhatsappData}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition duration-200"
              >
                Guardar
              </button>
            )}
          </div>
        }
      >
        <div className="flex flex-col gap-4">
          <label htmlFor="clientNotes" className="block text-xs leading-none font-semibold text-gray-700 mb-2">
            Estos datos se mostrarán en el apartado de notas adicionales y fecha tentativa de la primera reunión en el grupo de Whaa
          </label>
          
          {/* Indicador de estado de envío */}
          <div className="flex items-center gap-2 p-3 rounded-md border" style={{
            backgroundColor: data?.sentToGroup ? '#dcfce7' : '#fef3c7',
            borderColor: data?.sentToGroup ? '#86efac' : '#fde047'
          }}>
            <div className={`w-2 h-2 rounded-full ${data?.sentToGroup ? 'bg-green-500' : 'bg-yellow-500'}`}></div>
            <span className={`text-sm font-medium ${data?.sentToGroup ? 'text-green-800' : 'text-yellow-800'}`}>
              {data?.sentToGroup 
                ? '✓ Mensaje enviado al grupo de WhatsApp' 
                : '⚠ Mensaje no enviado al grupo de WhatsApp'}
            </span>
          </div>
          
          <div>
            <label htmlFor="messageNote" className="block text-sm font-medium text-gray-700 mb-2">
              Notas adicionales
            </label>
            <textarea
              id="messageNote"
              rows={4}
              value={messageNote}
              onChange={(e) => setMessageNote(e.target.value)}
              disabled={data?.sentToGroup}
              className={`w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                data?.sentToGroup ? 'bg-gray-100 cursor-not-allowed opacity-60' : ''
              }`}
              placeholder="Ingrese la nota del mensaje..."
            />
          </div>
          
          <div>
            <label htmlFor="fechaTentativaInicio" className="block text-sm font-medium text-gray-700 mb-2">
              Fecha tentativa de inicio
            </label>
            <input
              id="fechaTentativaInicio"
              type="datetime-local"
              value={fechaTentativaInicio}
              onChange={(e) => setFechaTentativaInicio(e.target.value)}
              disabled={data?.sentToGroup}
              className={`w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                data?.sentToGroup ? 'bg-gray-100 cursor-not-allowed opacity-60' : ''
              }`}
            />
          </div>
        </div>
      </ModalInDrawer>
    </DrawerRight>
  );
};

export default DrawerCotizacionDetails;

const Item = ({ title, children }) => {
  return (
    <div className="p-3 0 rounded-lg border  bg-white border-gray-300">
      <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
        {title}
      </dt>
      <dd className=" text-xs text-gray-400">{children}</dd>
    </div>
  );
};

const ItemTransaccion = ({ title, children }) => {
  return (
    <div className="p-3 0">
      <dt className="mb-2 font-semibold text-xs leading-none  text-gray-800">
        {title}
      </dt>
      <dd className="text-xs text-gray-600">{children}</dd>
    </div>
  );
};
